import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import moment from "moment";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  FORMATTED_TODAY_DATE_YYYYMMDD,
  getMaxDateUptoLastMonthDate,
  formatDateTimezon,
  convertThenFormat,
} from "../../common-data/Converts";
import { fetchMemberSubscriptionData } from "../../../redux/plans-reducers/plansSlice";
import Loader from "../../ui/Loader";
import MealsStructure from "../../diet/meal/MealsStructure";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";

const MembershipPauseForm = ({ userInfoData, closeModal, callFunction }) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    memberSubscription,
    memberSubscriptionLoading,
    memberSubscriptionError,
  } = useSelector((state) => state.plans);

  const [isFetchUser, setIsFetchUser] = useState(false);
  const [memberFetchedData, setMemberFetchedData] = useState(null);
  const iniMemStatus = {
    isShowForm: false,
    errorMessage: "",
  };
  const [memberStatus, setMemberStatus] = useState(iniMemStatus);
  const [expandedSections, setExpandedSections] = useState({
    regular: false,
    pt: false,
  });

  const initialFormValues = {
    memberMobile: "",
    memberName: "",
    memberEmail: "",
    selectedGym: "",
    memberInfo: "",

    pauseStartDate: "",
    pauseEndDate: "",
    pauseReason: "",
  };
  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "memberMobile" && value.length > 10) {
      return;
    }

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  function onClearNumber(e) {
    e && e.preventDefault();

    const handleConfirm = () => {
      setFormValues(initialFormValues);
      setIsFetchUser(false);
      setMemberFetchedData(null);
      setMemberStatus(iniMemStatus);
    };

    showConfirmAlert(handleConfirm, `You want to clear the form?`);
  }

  const toggleSection = (section) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section],
    });
  };

  const getSubsProgress = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();

    const totalDays = Math.ceil((end - start) / (1000 * 60 * 60 * 24));
    const daysLeft = Math.ceil((end - today) / (1000 * 60 * 60 * 24));

    return {
      daysLeft: daysLeft > 0 ? daysLeft : 0,
      totalDays: totalDays,
    };
  };

  const validateForm = (values) => {
    const errors = {};
    const today = moment().startOf("day");

    if (!values.pauseStartDate) {
      errors.pauseStartDate = "Pause Start Date is required!";
    } else if (moment(values.pauseStartDate).isBefore(today)) {
      errors.pauseStartDate = "Start date cannot be in the past!";
    }

    if (!values.pauseEndDate) {
      errors.pauseEndDate = "Pause End Date is required!";
    } else if (
      moment(values.pauseEndDate).isSameOrBefore(values.pauseStartDate)
    ) {
      errors.pauseStartDate = "End date must be after start date!";
      errors.pauseEndDate = "End date must be after start date!";
    }

    if (!values.pauseReason) {
      errors.pauseReason = "Pause Reason is required!";
    }

    return errors;
  };

  function getMemberDetails(filters) {
    dispatch(
      fetchMemberSubscriptionData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function onClickFetchUserDetails(e) {
    e.preventDefault();

    if (!formValues.memberMobile) {
      setFormErrors((prevErrors) => ({
        ...prevErrors,
        memberMobile: "Member Number Required!",
      }));

      return;
    }

    if (formValues.memberMobile && !formErrors.memberMobile) {
      const filters = {
        mobile_number: formValues.memberMobile,
      };

      setIsFetchUser(true);
      getMemberDetails(filters);
    }
  }

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = "/pause/pause-membership";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("result", result);

      if (result?.payload?.status) {
        setFormValues(initialFormValues);
        callFunction();
        closeModal();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage =
          result?.payload?.message ||
          result?.error?.message ||
          "Something Went Wrong!";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error making POST request:", error);
      toast.error(error?.message || "Something Went Wrong!");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const userData = {
        user_uid: formValues.memberInfo?.user_id || "",
        pause_start_date: formValues.pauseStartDate || "",
        pause_end_date: formValues.pauseEndDate || "",
        remark: formValues.pauseReason || "",
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `do you want to pause the membership for ${formValues.memberName}?`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  useEffect(() => {
    if (
      isFetchUser &&
      !memberSubscriptionLoading &&
      !formErrors.memberMobile &&
      !memberSubscriptionError &&
      memberSubscription?.status &&
      memberSubscription?.data?.length > 0
    ) {
      const memberData = memberSubscription.data;
      const { gym_name, gym_id, user_name, user_email, subscription_status } =
        memberData[0];

      if (subscription_status !== "active") {
        setMemberStatus({
          isShowForm: false,
          errorMessage: "Membership is not active. Cannot pause membership.",
        });
        setIsFetchUser(false);
        return;
      }

      setFormValues((prevs) => ({
        ...prevs,
        memberName: user_name,
        memberEmail: user_email,
        selectedMemberGym: {
          label: gym_name,
          value: gym_id,
        },
        memberInfo: memberData[0],
      }));

      setMemberFetchedData(memberData);
      setMemberStatus({
        isShowForm: true,
        errorMessage: "",
      });
      setIsFetchUser(false);
    } else if (
      isFetchUser &&
      !memberSubscriptionLoading &&
      !memberSubscriptionError &&
      (!memberSubscription?.status || memberSubscription?.data?.length === 0)
    ) {
      setMemberStatus({
        isShowForm: false,
        errorMessage: "No active memberships found for this member.",
      });
      setIsFetchUser(false);
    }
  }, [
    isFetchUser,
    memberSubscriptionLoading,
    memberSubscriptionError,
    formErrors.memberMobile,
    memberSubscription,
  ]);

  return (
    <div className="form-container mt-0">
      {/* <MealsStructure text="Membership Pause Form" /> */}

      {/* <CommonHeadingNBtns
        title={`New Membership Pause`}
        onClose={closeModal}
        btnTxt="submit"
        onClick={onSubmit}
        isLoading={postPutLoading}
      /> */}

      <form
        className="formContainer"
        onSubmit={onSubmit}
        style={{ marginTop: "30px" }}>
        <div className="formInputsGrid twoGridSystem input-with-btn">
          <div className="formInputBox">
            <label htmlFor="memberMobile" className={`formInputLabel`}>
              Member Mobile <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Member Mobile Number"
              className={`formInput ${
                formErrors?.memberMobile ? "formError" : ""
              }`}
              name="memberMobile"
              value={formValues.memberMobile}
              onChange={onChangeInput}
              maxLength={10}
            />

            <span className="error-label">
              {formErrors?.memberMobile || ""}
            </span>

            {!memberStatus.isShowForm && memberStatus.errorMessage && (
              <span className="info">{memberStatus.errorMessage || ""}</span>
            )}
          </div>

          <div className="formInputButtons">
            <Button
              type="button"
              className="saveBtn"
              variant="danger"
              onClick={onClickFetchUserDetails}
              disabled={memberFetchedData || formErrors.memberMobile}>
              {memberSubscriptionLoading ? <Loader /> : "Fetch Member Details"}
            </Button>
            {!memberSubscriptionLoading && (
              <Button
                type="button"
                className="cancelBtn"
                variant="dark"
                onClick={onClearNumber}>
                Clear
              </Button>
            )}
          </div>
        </div>

        {memberStatus.isShowForm && (
          <>
            <div className="formInputsGrid twoGridSystem">
              <div className="formInputBox">
                <label htmlFor="memberName" className="formInputLabel">
                  Member Name
                </label>
                <input
                  type="text"
                  className="formInput"
                  name="memberName"
                  value={formValues.memberName}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="memberEmail" className="formInputLabel">
                  Member Email
                </label>
                <input
                  type="email"
                  className="formInput"
                  name="memberEmail"
                  value={formValues.memberEmail}
                  disabled
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="pauseStartDate" className="formInputLabel">
                  Pause Start Date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  className={`formInput ${
                    formErrors.pauseStartDate ? "formError" : ""
                  } ${formValues.pauseStartDate ? "date-has-value" : ""}`}
                  name="pauseStartDate"
                  min={FORMATTED_TODAY_DATE_YYYYMMDD}
                  value={formValues.pauseStartDate}
                  onChange={onChangeInput}
                />
              </div>

              <div className="formInputBox">
                <label htmlFor="pauseEndDate" className="formInputLabel">
                  Pause End Date <span className="required">*</span>
                </label>

                <input
                  type="date"
                  className={`formInput ${
                    formErrors.pauseEndDate ? "formError" : ""
                  } ${formValues.pauseEndDate ? "date-has-value" : ""}`}
                  name="pauseEndDate"
                  min={
                    formValues.pauseStartDate || FORMATTED_TODAY_DATE_YYYYMMDD
                  }
                  max={getMaxDateUptoLastMonthDate()}
                  value={formValues.pauseEndDate}
                  onChange={onChangeInput}
                />
              </div>

              <div className="formInputBox span2">
                <label htmlFor="description" className="formInputLabel">
                  Pause Reason <span className="required">*</span>
                </label>

                <textarea
                  name="pauseReason"
                  className={`formInput ${
                    formErrors.pauseReason ? "formError" : ""
                  }`}
                  style={{
                    background: "#fff",
                  }}
                  placeholder="Enter Pause Reason"
                  value={formValues.pauseReason || ""}
                  onChange={(e) =>
                    setFormValues((prevs) => ({
                      ...prevs,
                      pauseReason: e.target.value,
                    }))
                  }></textarea>
              </div>

              {memberFetchedData && (
                <div className="memberships-container span2">
                  {/* Regular Memberships */}
                  <div className="membership-section">
                    <div
                      className={`section-header ${
                        expandedSections.regular ? "expanded" : ""
                      }`}
                      onClick={() => toggleSection("regular")}>
                      <div className="section-title">
                        Active Regular Memberships
                        <span className="count">
                          {
                            memberFetchedData.filter(
                              (item) =>
                                item.type === "regular" &&
                                item.subscription_status === "active"
                            ).length
                          }
                        </span>
                        {/* <span className="collapsible-indicator">
                        {expandedSections.regular ? 'Click to collapse' : 'Click to expand'}
                      </span> */}
                      </div>
                    </div>

                    <div
                      className={`plans-grid ${
                        expandedSections.regular ? "expanded" : ""
                      }`}>
                      {memberFetchedData.some(
                        (item) =>
                          item.type === "regular" &&
                          item.subscription_status === "active"
                      ) ? (
                        memberFetchedData
                          .filter(
                            (item) =>
                              item.type === "regular" &&
                              item.subscription_status === "active"
                          )
                          .map((item, index) => {
                            const {
                              plan_name,
                              price,
                              start_date,
                              expire_date,
                            } = item || {};

                            const startDate = start_date
                              ? formatDateTimezon(start_date).split(" ")[0]
                              : "-";
                            const endDate = expire_date
                              ? formatDateTimezon(expire_date).split(" ")[0]
                              : "-";
                            const daysLeft = getSubsProgress(
                              start_date,
                              expire_date
                            ).daysLeft;

                            return (
                              <div className="plan-card" key={index}>
                                <div className="plan-header">
                                  <div>
                                    <h3 className="plan-name">
                                      {plan_name || "WTF Yearly"}
                                    </h3>
                                    <div className="plan-type">
                                      Regular Membership
                                    </div>
                                  </div>
                                  <span className="status">ACTIVE</span>
                                </div>

                                <div className="plan-body">
                                  <div className="plan-detail">
                                    <div className="detail-label">Price:</div>
                                    <div className="detail-value price">
                                      ₹{convertThenFormat(price || 0)}
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">
                                      Duration:
                                    </div>
                                    <div className="detail-value">
                                      {startDate} - {endDate}
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">
                                      Remaining:
                                    </div>
                                    <div className="detail-value">
                                      <span className="days-left">
                                        {daysLeft} days
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div className="empty-message">
                          No active regular memberships
                        </div>
                      )}
                    </div>
                  </div>

                  {/* PT Memberships */}
                  <div className="membership-section mt15">
                    <div
                      className={`section-header ${
                        expandedSections.pt ? "expanded" : ""
                      } ${formErrors.ptSubscription ? "error" : ""}`}
                      onClick={() => toggleSection("pt")}>
                      <div className="section-title">
                        Active Personal Training
                        <span className="count">
                          {
                            memberFetchedData.filter(
                              (item) =>
                                item.type === "addon_pt" &&
                                item.subscription_status === "active"
                            ).length
                          }
                        </span>
                        {formErrors.ptSubscription && (
                          <span className="error-message">
                            {formErrors.ptSubscription}
                          </span>
                        )}
                      </div>
                    </div>

                    <div
                      className={`plans-grid ${
                        expandedSections.pt ? "expanded" : ""
                      }`}>
                      {memberFetchedData.some(
                        (item) =>
                          item.type === "addon_pt" &&
                          item.subscription_status === "active"
                      ) ? (
                        memberFetchedData
                          .filter(
                            (item) =>
                              item.type === "addon_pt" &&
                              item.subscription_status === "active"
                          )
                          .map((item, index) => {
                            const {
                              addon_name,
                              price,
                              start_date,
                              expire_date,
                              trainer_name,
                              completed_session,
                              n_session,
                              pt_duration,
                            } = item || {};

                            const startDate = start_date
                              ? formatDateTimezon(start_date).split(" ")[0]
                              : "-";
                            const endDate = expire_date
                              ? formatDateTimezon(expire_date).split(" ")[0]
                              : "-";
                            const daysLeft = getSubsProgress(
                              start_date,
                              expire_date
                            ).daysLeft;
                            const isSelected = false;
                            // const isSelected = selectedPlan === uid;

                            return (
                              <div
                                className={`plan-card ${
                                  isSelected ? "selected" : ""
                                }`}
                                key={index}>
                                <div className="plan-header">
                                  <div>
                                    <h3 className="plan-name">
                                      {addon_name || "PT Sessions"}
                                    </h3>
                                    <div className="plan-type">
                                      Personal Training
                                    </div>
                                  </div>
                                  <span className="status">ACTIVE</span>
                                </div>

                                <div className="plan-body">
                                  <div className="trainer-box">
                                    <div className="trainer-avatar">
                                      {(trainer_name || "T")[0].toUpperCase()}
                                    </div>
                                    <div className="trainer-info">
                                      <div className="trainer-name">
                                        {trainer_name || "Not assigned"}
                                      </div>
                                      <div className="trainer-title">
                                        Trainer
                                      </div>
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">Price:</div>
                                    <div className="detail-value price">
                                      ₹{convertThenFormat(price || 0)}
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">
                                      Duration:
                                    </div>
                                    <div className="detail-value">
                                      {startDate} - {endDate}
                                    </div>
                                  </div>

                                  <div className="plan-detail">
                                    <div className="detail-label">
                                      Session Status:
                                    </div>
                                    <div className="detail-value">
                                      <span className="days-left">
                                        {completed_session} / {n_session}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                      ) : (
                        <div className="empty-message">
                          No active PT memberships
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <CloseSubmitBtn
              closeLabel="Cancel"
              submitLabel={"Pause Membership"}
              onClose={closeModal}
              onSubmit={onSubmit}
              isLoading={postPutLoading}
            />
          </>
        )}
      </form>
    </div>
  );
};

export default MembershipPauseForm;
